<template slot-scope="scope">
  <!-- 代开发票表格组件 -->
  <div class="device-list">
    <div class="device-list-tab">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#409eff ',
          textAlign: 'center',
          color: '#ffffff',
          padding: '3px',
          fontSize: '12px',
          fontWeight: '400',
          height: '45px',
        }"
        @selection-change="handleSelectionChange"
        :row-key="getRowKeys"
        ref="multipleTable"
        :row-style="{ height: '35px' }"
      >
        <el-table-column
          :reserve-selection="true"
          type="selection"
          width="55"
          align="center"
        >
        </el-table-column>
        <el-table-column label="订单ID" align="center" width="210">
          <template slot-scope="scope">
            <span>{{ scope.row.orderNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column label="消费类型" align="center" >
          <template slot-scope="scope">
            <span>{{ scope.row.consumptionTypeStr }}</span>
          </template>
        </el-table-column>
        <el-table-column label="服务内容" align="center" >
          <template slot-scope="scope">
            <span>{{ scope.row.serviceContent }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="实付金额（元）"
          align="center"
          
        >
          <template slot-scope="scope">
            <span>{{ scope.row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="可开票金额（元）"
          align="center"
         
          
        >
          <template slot-scope="scope">
            <span>{{ scope.row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="订单支付时间"
          align="center"
          width="140"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.orderTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span class="table-p" @click="handleEdit(scope.$index, scope.row)"
              >开具发票</span
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <ticketDialog
      :dialogVisible="dialogVisible"
      :num="num"
      :acquiesce="acquiesce"
      :headList="dataOption.headList"
      :mailList="dataOption.mailList"
      :addressList="dataOption.addressList"
      :isReissue="false"
      :isBatch="true"
      @handleCloseDele="handleCloseDele"
      @handleUnderstand="handleUnderstand"
    ></ticketDialog>
  </div>
</template>

<script>
// 引入接口
import {
  getDefaultHeadAndMailInfo, // 代开发票获取默认抬头与地址邮箱
  getInvoiceHeadAndMailInfo, //查看发票相关信息，发票抬头，邮寄地址，电子邮箱地址
  batchIssueInvoice, // 批量开票
} from "../../../../../assets/api/firm/firmCenter";
// 清空选中 this.$refs.multipleTable.clearSelection();
// 引入代开发票弹窗 组件
import ticketDialog from "./ticketDialog.vue";
export default {
  props: {
    tableData: {},
    select: {},
    ClearSel: {}, // 监听此数据 改变清空选中
    verifyData: {}, // 法人信息 是否实名认证等  用于开票前判断
  },
  components: {
    ticketDialog,
  },
  data() {
    return {
      multipleSelection: [], //多选
      dialogVisible: false, // 开票弹窗
      num: "", // 消费类型
      acquiesce: {}, // 设置的默认
      dataOption: {}, // 抬头/地址/邮箱  选项
      recordId: [], // 单个开票 的id
    };
  },
  watch: {
    // 监听
    ClearSel: {
      handler() {
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.clearSelection();
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {},
  methods: {
    getRowKeys(row) {
      return row.id;
    },
    //关闭弹窗
    handleCloseDele() {
      this.dialogVisible = false;
    },
    // 弹窗确认
    handleUnderstand(val, unlockConfirm) {
      const unlock =
        typeof unlockConfirm === "function" ? unlockConfirm : null;
      // 调用批量开票接口
      var data = {
        data: {
          ownerType: 1, //开票主体类型 个人0 企业1
          ownerId: this.$store.getters.getCompany.id, //开票主体id
          recordIdList: this.recordId, // 消费记录id
          type: Number(val.listArrSelect), //0电子1纸质
          headId: val.value, //抬头id
          attribute: Number(val.listArrSelect1), //0普通增值税发票1专用
          mailOrAddressId:
            val.listArrSelect == 0
              ? val.sendMail == 1
                ? val.value1
                : ""
              : val.value2, //邮箱/地址
          showFlag: val.showFlag, //是否展示 0否 1是
          sendMail: val.sendMail, //是否发送邮箱 0否 1是
        },
      };
      batchIssueInvoice(data)
        .then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");
            this.dialogVisible = false;
            this.$nextTick(() => {
              this.$emit("Refresh");
            });
          }
        })
        .finally(() => {
          unlock && unlock();
        });
    },
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
      const amount = this.$tool.num.sum(val, (item) => item.amount);
      console.log(val, amount, "多选");
      this.$emit("handleSelectionChange", amount, val);
    },
    // 代开发票
    handleEdit(index, row) {
      if (this.verifyData.auditStatus == 3) {
        this.recordId[0] = row.id;
        this.num = row.consumptionType; // 获取消费类型
        // 获取所属发票抬头列表 接口 (代开发票弹窗中使用)
        this.getDefaultHeadAndMailInfo();
        this.getInvoiceHeadAndMailInfo();
        setTimeout(() => {
          this.dialogVisible = true;
        }, 100);
      }else{
        this.$tool.PromptBox("warning", "请先在企业安全管理中进行实名认证！");
      }
    },
    //获取默认的地址/邮箱/抬头 接口
    async getDefaultHeadAndMailInfo() {
      var data = {
        data: {
          ownerType: 1, //开票主体类型 个人0 企业1
          ownerId: this.$store.getters.getCompany.id, //开票主体id
        },
      };
      // 获取默认的地址/邮箱/抬头 接口
      const res1 = await getDefaultHeadAndMailInfo(data);
      this.acquiesce = res1.data;
    },
    //  获取 抬头/地址/邮箱  数据传给弹窗用于选择
    async getInvoiceHeadAndMailInfo() {
      var data = {
        data: {
          ownerType: 1, //开票主体类型 个人0 企业1
          ownerId: this.$store.getters.getCompany.id, //开票主体id
        },
      };
      const res = await getInvoiceHeadAndMailInfo(data);
      this.dataOption = res.data;
    },

    //表格颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else if (rowIndex % 2 == 1) {
        return "success-row";
      }
      return "success-row";
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-checkbox__inner {
  border: 1px solid #409eff ;
}

.table-p {
  display: inline-block;
  width: 80px;
  height: 26px;
  border-radius: 5px;
  background: #409eff ;
  text-align: center;
  color: #ffffff;
  line-height: 26px;
  cursor: pointer;
}
// 表格头部的圆弧
/deep/th:nth-child(1) {
  border-radius: 10px 0 0 0 !important;
}
// 表格头部的圆弧
/deep/th:nth-last-child(1) {
  border-radius: 0px 10px 0px 0px !important;
}

// 表格行高
/deep/th {
  height: 45px !important;
  padding: 0;
}
/deep/ td {
  height: 40px !important;
  padding: 0;
}
.device-list-tab {
  border: 1px solid #eeeeee;
  border-radius: 10px 10px 0 0;
}
/deep/.el-table__empty-block,
/deep/.el-table tr,
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  color: #333333;
  font-weight: 400;
  font-size: 12px;
}
/deep/.el-table .warning-row td {
  font-size: 12px;
  color: #333333;
}

::v-deep .el-table .warning-row td {
  background: #eeeeee !important;
}
/deep/.device-list {
  border: 1px solid goldenrod !important;
}

</style>
